export const addressLine1 = str => true;

export const addressLine2 = str => true;

export const city = str => /^[A-Za-z\s\d\.\-'‘]{1,100}$/.test(str);

export const zip = str => /^[\d]{5,5}$/.test(str);

export const email = str => /^.*\@.*\..*$/.test(str) && str.length > 3;

export const name = str => /^[0-9A-Za-z\s\-\'\‘]/.test(str);

export const password = str => (
  str.length > 7
  && str.length < 100
  && /[A-Z]/.test(str)
  && /[a-z]/.test(str)
  && /[0-9]/.test(str)
);

export const phone = str => /^[0-9]{10,10}$/.test(str);
